/* CAUTION: When using the generators, this file is modified in some places.
 *          This is done via AST traversal - Some of your formatting may be lost
 *          in the process - no functionality should be broken though.
 *          This modifications only run once when the generator is invoked - if
 *          you edit them, they are not updated again.
 */
import React, {
  Component,
  PropTypes
} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {} from '../actions/';
import Main from '../components/App';
import {authUserAction, fetchSummaryInfo, setLocale} from '../actions';
import config from 'config'; // Import the dynamically resolved config

/* Populated by react-webpack-redux:reducer */

class App extends Component {

  
  componentDidMount() {
 
    const useMockAdal = config.appEnv === 'dev'; // Use mock ADAL if appEnv is 'dev'
    console.log("config.useMockAdal ", useMockAdal);
    
  }

  render() {
    const { router } = this.props;
    const { actions } = this.props;
    const { locale } = this.props;
    return <Main router={router} locale={locale} actions={actions} authInfo={this.props.authInfo}> {this.props.children} </Main>;
  }

}
/* Populated by react-webpack-redux:reducer
 *
 * HINT: if you adjust the initial type of your reducer, you will also have to
 *       adjust it here.
 */
App.propTypes = {
  actions: PropTypes.shape({})
};


function mapStateToProps(state) { // eslint-disable-line no-unused-vars
  /* Populated by react-webpack-redux:reducer */
  const props = {...state};
  return props;
}

function mapDispatchToProps(dispatch) {
  /* Populated by react-webpack-redux:action */
  const actions = {
    authUserAction,
    fetchSummaryInfo,
    setLocale
  };
  const actionMap = { actions: bindActionCreators(actions, dispatch) , dispatch : dispatch };
  return actionMap;
}
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./containers/App.js